import React from 'react';
import PropTypes from 'prop-types';

import Card from '../../Card';
import FileGridItem from './FileGridItem';
import './file-grid.css';

const FileGrid = ({ files, handleFileClick  }) => {
	return (
		<Card>
			<div className="file-grid">
				{
					files.map(file => {
						return (
							<FileGridItem key={file.id} file={file} handleFileClick={handleFileClick} />
						)
					})
				}
			</div>
		</Card>
	);
};

FileGrid.propTypes = {
	files: PropTypes.arrayOf(
		PropTypes.object.isRequired,
	).isRequired,
	handleFileClick: PropTypes.func.isRequired,
}

export default FileGrid;


// WEBPACK FOOTER //
// ./src/components/common/files/FileGrid/index.js